<template>
    <!-- 权限配置 -->
    <div class="page-container" id="permissionConfigurationContainer">
        <el-row :gutter="5">
            <el-col :span="6">
                <el-input size="mini" v-model="permissionConfigForm.use_code" placeholder="输入名称按'回车'快速定位"></el-input>
                <el-row style="margin-top: 8px">
                    <el-col>
                        <el-row class="name-css" :class="{ selectBg: index === isactive }" v-for="(item, index) in nameList" :key="index" @click.native="handlerSelect(index)">
                            {{item}}
                        </el-row>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="18">
                <el-form :model="permissionConfigForm" :rules="permissionConfigFormRules" ref="ruleFormRef" class="form-panel" label-position="top"
                    :validateOnRuleChange="false">
                    <el-col :span="24">
                        <el-row class="content-panel">
                            <el-col style="margin-bottom:8px">
                                <el-button type="primary" size="small" plain @click="handleAdd">新增</el-button>
                                <el-button type="primary" size="small" plain @click="handleAdd">保存</el-button>
                                <el-button type="primary" size="small" plain @click="handleAdd">导入权限</el-button>
                                <el-button type="danger" size="small" plain @click="handleResetPwd">删除角色</el-button>
                                <el-button type="primary" size="small" plain @click="handleEnable">单个角色缓存刷新</el-button>
                                <el-button type="danger" size="small" plain @click="handleDisable">刷新所有缓存</el-button>
                            </el-col>
                            <el-col>
                                <el-row :gutter="22">
                                    <el-col :span="8">
                                        <el-form-item label="角色代码" prop="use_code">
                                            <el-input size="mini" v-model="permissionConfigForm.use_code"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="角色名称" prop="user_name_cn">
                                            <el-input size="mini" v-model="permissionConfigForm.user_name_cn"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="上级角色" prop="userType">
                                            <el-select class="length_input" size="mini" v-model="permissionConfigForm.userType"
                                                placeholder="请选择">
                                                <el-option
                                                v-for="item in isValidList"
                                                :key="item.key"
                                                :label="item.value"
                                                :value="item.key"
                                                >
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="22">
                                    <el-col :span="16">
                                        <el-form-item label="角色描述" prop="user_name_cn">
                                            <el-input size="mini" v-model="permissionConfigForm.user_name_cn"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">
                                        <el-form-item label="主数据ID">
                                            <el-input size="mini" v-model="permissionConfigForm.user_name_cn"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-col>
                        </el-row>
                        <!-- 表格-start -->
                        <el-row style="margin-top: 15px">
                            <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
                                <el-tab-pane label="业务组织" name="1">
                                    <el-form :model="orgForm" :rules="orgFormRules" ref="orgFormRef" label-position="top">
                                        <el-row>
                                            <el-col :span="6">
                                                <el-form-item label="默认组织" prop="use_code">
                                                    <el-input size="mini" v-model="orgForm.use_code"></el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                        <el-row>
                                            <el-tree
                                                :data="data"
                                                show-checkbox
                                                node-key="id"
                                                :props="defaultProps">
                                            </el-tree>
                                        </el-row>
                                    </el-form>
                                </el-tab-pane>
                                <el-tab-pane label="角色用户" name="2"></el-tab-pane>
                            </el-tabs>
                        </el-row>
                    </el-col>
                </el-form>
            </el-col>
        </el-row>
    </div>
</template>

<script>
export default {
    data() {
        return {
            nameList: ['分公司系统管理员', '整箱操作'],
            isactive:0, //默认第一个有样式
            activeName: '1',
				permissionConfigForm: {},
				// 分页
				pageConfig: {
					layout: 'total, sizes, prev, pager, next, jumper',
					total: 0,
					pageSize: 10,
					pagerCount: 10,
					currentPage: 1,
					pageSizes: [10, 20, 50, 100]
				},
				// currentPage 改变时会触发
				handleCurrentChange(val) {
					console.log(`当前页: ${val}`)
					this.pageConfig.currentPage = val
				},
				// 校验
				permissionConfigFormRules: {
                    use_code: [{ required: true, message: '' }],
                },
                orgForm: {},
                orgFormRules: {
                    use_code: [{ required: true, message: '' }],
                },
				// 表格数据
				userManagementTableDataSource: [],
				// 表格设置
				userManagementTableSettings: {
					height: 360,
					stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
					...this.$systemConfig.tableConfig

				},
                isValidList: [
                    {
                        key: '1',
                        value: '是'
                    },
                    {
                        key: '0',
                        value: '否'
                    }
                ],
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [{
                        text: '今天',
                        onClick(picker) {
                        picker.$emit('pick', new Date());
                        }
                    }, {
                        text: '昨天',
                        onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24);
                        picker.$emit('pick', date);
                        }
                    }, {
                        text: '一周前',
                        onClick(picker) {
                        const date = new Date();
                        date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', date);
                        }
                    }]
                },
               data: [{
                id: 1,
                label: '公共相关',
                    children: [{
                        id: 4,
                        label: '二级 1-1',
                        children: [{
                        id: 9,
                        label: '三级 1-1-1'
                        }, {
                        id: 10,
                        label: '三级 1-1-2'
                        }]
                    }]
                }, {
                id: 2,
                    label: '结算管理',
                    children: [{
                        id: 5,
                        label: '二级 2-1'
                    }, {
                        id: 6,
                        label: '二级 2-2'
                    }]
                }, {
                id: 3,
                label: '价格协议',
                    children: [{
                        id: 7,
                        label: '二级 3-1'
                    }, {
                        id: 8,
                        label: '二级 3-2'
                    }]
                    }],
                    defaultProps: {
                    children: 'children',
                    label: 'label'
                }
        };
    },
    async created() {

    },
    mounted() {

    },
    methods: {
        loadNode(node, resolve) {
            if (node.level === 0) {
            return resolve([{ name: '华贸股份' }]);
            }
            if (node.level > 1) return resolve([]);

            setTimeout(() => {
            const data = [{
                name: 'leaf',
                leaf: true
            }, {
                name: 'zone'
            }];

            resolve(data);
            }, 500);
        },
        // 新增
        handleAdd() {
            this.$router.push({
                path: '/system/usermaintain'
            })
        },
        // 重置密码
        handleResetPwd() {

        },
        // 启用
        handleEnable() {

        },
        // 禁用
        handleDisable() {

        },
        // 查询
        handleQuery() {

        },
        // 重置
        handleReset() {

        },
        // pageSize 改变时会触发
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`)
            this.pageConfig.pageSize = val
        },
        // currentPage 改变时会触发
        handleCurrentChange(val) {
            this.pageConfig.currentPage = val
        },
        handlerSelect(index) {
            //点击切换 变量的值 赋值为 index
            this.isactive=index;
        }
    }
};
</script>

<style scoped lang="scss">
    .name-css {
        font-size: 14px;
        padding: 4px 2px;
        cursor: pointer;
    }
    .selectBg {
        background: #e1e9fa;
    }
</style>
